import { strings } from '@/services/translation/strings';
import { format } from 'date-fns';
import { FC } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { DateInput } from './DateInput';

const arrowButtonClass =
  'flex h-10 w-10 items-center justify-center rounded-md bg-gray-100 text-gray-700 hover:bg-gray-200 ' +
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-green-600';

export const PeriodPicker: FC<{
  label?: string;
  date: Date;
  displayFormat: string;
  yearOnly?: boolean;
  yearStartMonth?: number;
  formatYear?: (year: number) => string;
  onPick: (date: Date) => void;
  onPrevious: () => void;
  onNext: () => void;
}> = ({ label, date, displayFormat, yearOnly, yearStartMonth = 1, formatYear, onPick, onPrevious, onNext }) => {
  const selectedYear = date.getFullYear();
  const yearLabel = formatYear
    ? formatYear(selectedYear)
    : `${format(new Date(selectedYear, yearStartMonth - 1, 1), 'MMM yyyy')} - ${format(
        new Date(selectedYear + 1, yearStartMonth - 1, 0),
        'MMM yyyy'
      )}`;

  return (
    <div className="flex flex-col gap-1">
      {label && <span className="text-sm font-semibold">{label}</span>}
      <div className="flex items-center gap-2">
        <button type="button" className={arrowButtonClass} onClick={onPrevious} aria-label={strings.common.previous}>
          <FiChevronLeft />
        </button>
        {yearOnly ? (
          <span className="w-64 text-center text-sm font-medium text-gray-700" aria-live="polite">
            {yearLabel}
          </span>
        ) : (
          <DateInput className="w-64" value={date} onChange={d => d && onPick(d)} displayFormat={displayFormat} />
        )}
        <button type="button" className={arrowButtonClass} onClick={onNext} aria-label={strings.common.next}>
          <FiChevronRight />
        </button>
      </div>
    </div>
  );
};
